// extracted by mini-css-extract-plugin
export default {"calendarLabel":"_3_tefFXiER-UKXtKBopKji"};